<template>
    <div>
        <Boyo-Dialog :dialogInfo="dialogInfoData"
                    @dialogEvent="dialogEventData">
            <div style="display: flex; flex-direction: row; align-items: flex-start;">
              <!-- 左侧竖向步骤条 -->
              <div style="width: 240px; min-width: 240px; margin-right: 24px;">
                <el-steps direction="vertical" :active="activeValue" class="custom-steps-vertical">
                  <el-step v-for="(itemf, index) of activeList"
                          :key="index" :title="itemf.processNodeName" :status="itemf.stepStatus || 'process'">
                    <template slot="description">
                      <div v-if="itemf.processNodeName === '制单人'">
                        {{ itemf.approvalTime }}
                      </div>
                      <div v-else>
                        <div style="border-top: 1px solid #e4e7ed; margin: 8px 0;"></div>
                        <div>流程节点：{{ itemf.processNodeName || '' }}</div>
                        <div>经办人：{{ itemf.maker || '' }}</div>
                        <div v-if="itemf.stepStatus !== 'process'">备注：{{ itemf.remark || (itemf.stepStatus === 'success' ? '通过' : '拒绝') }}</div>
                        <div>时间：{{ itemf.makerTime || '' }}</div>
                      </div>
                    </template>
                  </el-step>
                </el-steps>
              </div>
              <!-- 右侧内容 -->
              <div style="flex: 1; overflow-x: auto;">
                <Boyo-Formtwo :formInfo="formInfo"
                        :refObj.sync="formInfo.ref"
                        :listTypeInfo='listTypeInfo'
                        @handlePictureCardPreview="handlePictureCardPreview">
                </Boyo-Formtwo>
                <el-table :data="tableData"
                        border
                        max-height="430"
                        style="width: 99%;"
                        :header-cell-style="{background:'rgb(189,215,252)',color:'#3C3C3C',padding:'4px 0'}"
                        :cell-style="{padding:'2px'}">
                        <el-table-column fixed="left"
                        type="index"
                        width="50">
                        </el-table-column>
                   <el-table-column 
    prop="PartnerName"
    align="center"
    label="客户名称"
    width="100"
  ></el-table-column>
  <el-table-column 
    prop="partnerIdNumber"
    align="center"
    label="客户身份证"
    width="120"
  ></el-table-column>
  <el-table-column 
    prop="materialName"
    align="center"
    label="品名"
    width="110"
  ></el-table-column>
  <el-table-column 
    prop="quantity"
    align="center"
    label="吨位"
  ></el-table-column>
  <el-table-column 
    v-if="detailDate.transportMode === 0||detailDate.transportMode === 2"
    prop="netWeight"
    align="center"
    label="过磅吨位(净重)"
  ></el-table-column>
  <el-table-column 
    v-if="detailDate.transportMode === 0||detailDate.transportMode === 2"
    prop="carDeductWeight"
    align="center"
    label="扣杂吨位"
  ></el-table-column>
  <el-table-column 
    v-if="detailDate.transportMode === 0||detailDate.transportMode === 2"
    prop="settleQuantity"
    align="center"
    label="结算吨位"
  ></el-table-column>
  <el-table-column 
    prop="settleExctTaxAmount"
    align="center"
    label="金额"
  ></el-table-column>
  <el-table-column 
    v-if="detailDate.transportMode === 2"
    prop="leadSealNumber"
    align="center"
    label="封号"
  ></el-table-column>
  <el-table-column 
    prop="address"
    align="center"
    label="地址"
  ></el-table-column>
  <el-table-column 
    v-if="detailDate.transportMode === 0||detailDate.transportMode === 2"
    prop="loaderName"
    align="center"
    label="装柜人员"
  ></el-table-column>
  <el-table-column 
    prop="note"
    align="center"
    label="备注"
  ></el-table-column>
  <el-table-column 
    prop="price"
    align="center"
    label="合同单价"
  ></el-table-column>

  <el-table-column 
    v-if="detailDate.transportMode === 0||detailDate.transportMode === 2"
    prop="idImage"
    align="center"
    label="身份证照片"
  >
    <template v-slot="scope">
      <a 
        class="el-icon-view" 
        v-if="scope.row.idImage"
        @click="handlePictureCardPreview(scope.row.idImage)"
      >
        查看
      </a>
      <span v-else>暂无</span>
    </template>
  </el-table-column>
  <el-table-column 
   v-if="detailDate.transportMode === 0||detailDate.transportMode === 2"
    prop="carNoImage"
    align="center"
    label="车牌号照片"
  >
    <template v-slot="scope">
      <a 
        class="el-icon-view" 
        v-if="scope.row.carNoImage"
        @click="handlePictureCardPreview(scope.row.carNoImage)"
      >
        查看
      </a>
      <span v-else>暂无</span>
    </template>
  </el-table-column>
  <el-table-column 
    v-if="detailDate.transportMode === 0||detailDate.transportMode === 2"
    prop="drivingLicenseImage"
    align="center"
    label="驾驶证照片"
  >
    <template v-slot="scope">
      <a 
        class="el-icon-view" 
        v-if="scope.row.drivingLicenseImage"
        @click="handlePictureCardPreview(scope.row.drivingLicenseImage)"
      >
        查看
      </a>
      <span v-else>暂无</span>
    </template>
  </el-table-column>
  <el-table-column 
    v-if="detailDate.transportMode === 0||detailDate.transportMode === 2"
    prop="sealNumberImage"
    align="center"
    label="铅封号照片"
  >
    <template v-slot="scope">
      <a 
        class="el-icon-view" 
        v-if="scope.row.sealNumberImage"
        @click="handlePictureCardPreview(scope.row.sealNumberImage)"
      >
        查看
      </a>
      <span v-else>暂无</span>
    </template>
  </el-table-column>
  <el-table-column 
    v-if="detailDate.transportMode === 0||detailDate.transportMode === 2"
    prop="containerImage"
    align="center"
    label="集装箱照片"
  >
    <template v-slot="scope">
      <a 
        class="el-icon-view" 
        v-if="scope.row.containerImage"
        @click="handlePictureCardPreview(scope.row.containerImage)"
      >
        查看
      </a>
      <span v-else>暂无</span>
    </template>
  </el-table-column>
  <el-table-column 
    v-if="detailDate.transportMode === 0||detailDate.transportMode === 2"
    prop="weighImage"
    align="center"
    label="称重单照片"
  >
    <template v-slot="scope">
      <a 
        class="el-icon-view" 
        v-if="scope.row.weighImage"
        @click="handlePictureCardPreview(scope.row.weighImage)"
      >
        查看
      </a>
      <span v-else>暂无</span>
    </template>
  </el-table-column>
  <el-table-column 
    prop="annex"
    align="center"
    label="附件"
    width="120"
  >
    <template v-slot="scope">
      <a 
        class="el-icon-view" 
        v-if="scope.row.annex"
        @click="viewFile(scope.row.annex)"
      >
        查看
      </a>
      <span v-else>暂无</span>
    </template>
  </el-table-column>

  <el-table-column 
    prop="completedFlag"
    align="center"
    label="确定状态"
    width="100"
  >
    <template v-slot="scope">
      {{ scope.row.completedFlag === 1 ? '已确认' : '未确认' }}
    </template>
  </el-table-column>
  <el-table-column 
    prop="reviewBy"
    align="center"
    label="复核人"
    width="100"
  ></el-table-column>
  <el-table-column 
    prop="reviewDate" 
    align="center"
    label="复核时间"
    width="150"
  ></el-table-column>
</el-table>
                
                <!-- 审核表单 -->
                <div v-if="showAuditForm" style="margin-top: 20px; border-top: 1px solid #ebeef5; padding-top: 20px;">
                   <!-- 添加快捷短语区域 -->
        <div class="quick-phrase-area">
          <div class="quick-phrase-label">常用快捷短语:</div>
          <div class="quick-phrase-buttons">
            <el-button 
                v-for="(phrase, index) in quickPhrases" 
                :key="index"
                size="mini"
                @click="insertQuickPhrase(phrase)"
                class="phrase-btn">
                {{ phrase }}
            </el-button>
          </div>
        </div>
                  <Boyo-Formtwo :formInfo="formInfo2"
                             :refObj.sync="formInfo2.ref"
                             :listTypeInfo="listTypeInfo">
                  </Boyo-Formtwo>
                </div>
              </div>
            </div>
        </Boyo-Dialog>
    </div>
</template>

<script>
import BoyoDialog from '@/components/BoyoDialog'
import BoyoFormtwo from '@/components/BoyoFormtwo'
import config from '@/api/config'
export default {
  name: 'ContainerApprovalDialog',
  components: {
    BoyoDialog,
    BoyoFormtwo
  },
  data () {
    return {
      billId: null,
      dataId: null,
      createdBy: null,
      createdTime: null,
      activeValue: 0,
      activeList: [],
      tableData: [],
      pingImgUrl: config.pingImgUrl,
      detailDate: {},
      quickPhrases: [
            '同意',
            '不同意',
            '装柜复核',
            '需要补充相关附件',
            '集装箱信息与实际不符'
        ],
        showPhraseManager: false,
        newPhrase: '',
      listTypeInfo: {
        processId: [],
        statusFlag2:[{value:1,label:'同意'},{value:2,label:'不同意'}],
        completedFlag: [{ value: 1, label: '已确认' }, { value: 0, label: '未确认' }],
        transportModeTwo: [{ value: 0, label: '车运' }, { value: 1, label: '船运' }, { value: 2, label: '集装箱' }]
      },
      dialogInfoData: {
        visible: false,
        type: 'update',
        title: {
          update: '装柜复核审批详情'
        },
        width: '90%',
        btList: [
          { label: '审核', type: 'success', icon: '', event: 'save', loading: false, show: false},
          {
            label: '关闭',
            event: 'close',
            show: true
          }
        ]
      },
      // 基础信息表单
      formInfo: {
        ref: null,
        labelWidth: "100px",
        inline: true,
        data: {
          containerNumber: '',
          contractId: '',
          cabinetPartnerName: '',
          transportMode: '',
          announcerTime: '',
          bookingTime: '',
          carrierName: '',
          carNo:'',
          sort:'',
          purLogisticsCode:'',
          weightTime:'',
        },
        list: [
          { type: 'text', label: '序号：', value: 'sort', style: 'width:90%', transportMode: '车-箱', className: 'form_item_two', disabled: true},
          { type: 'text', label: '集装箱号：', value: 'containerNumber', style: 'width:90%',transportMode: '车-箱',  className: 'form_item_two', disabled: true},
          { type: 'text', label: '车牌号：', value: 'carNo', transportMode: '车', style: 'width:90%', className: 'form_item_two', disabled: true},
          { type: 'text', label: '合同号：', value: 'contractId', transportMode: '车-箱',style: 'width:90%', className: 'form_item_two', disabled: true},
          { type: 'text', label: '运费合同：', value: 'purLogisticsCode', transportMode: '车-箱', style: 'width:90%', className: 'form_item_two', disabled: true},
          { type: 'text', label: '承运商：', value: 'carrierName', transportMode: '车-箱', style: 'width:90%', className: 'form_item_two', disabled: true},
          { type: 'text', label: '报柜日期：', value: 'announcerTime', transportMode: '车-箱-船', style: 'width:90%', className: 'form_item_two', disabled: true},
          { type: 'text', label: '过磅时间：', value: 'weightTime', style: 'width:90%', transportMode: '车', className: 'form_item_two', disabled: true},
          { type: 'text', label: '订柜日期：', value: 'bookingTime', style: 'width:90%',  transportMode: '车-箱', className: 'form_item_two', disabled: true},
          
        ],
        rules: {}
      },
      // 审核表单相关
      auditParm: {},
      showAuditForm: false, // 是否显示审核表单
      formInfo2: {
        ref: null,
        labelWidth: '100px',
        data: {
          id: '',
          processId: '',
          status: 1,
          remark: ''
        },
        list: [
          { type: 'select流程名称：', label: '流程名称：', value: 'processId', list: 'processId', style: 'width:80%', disabled: true },
          { type: 'selectRadio', label: '审核：', value: 'status', style: 'width:95%', className: 'form_item_one', list: 'statusFlag2', unclearable: true },
          { type: 'text', label: '备注：', value: 'remark', style: 'width:80%' }
        ],
        rules: {
          status: [{ required: true, trigger: 'change', message: '请选择审核结果' }]
        }
      }
    }
  },
  mounted () {
    // 加载流程枚举数据
    this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {
      if(res.code == 0) {
        let list1 = res.data.list
        for(let i in list1) {
          this.listTypeInfo.processId.push({value: list1[i].processId, enumValue: list1[i].processCode, label: list1[i].name})
        }
      }
    })
  },
  methods: {
    // 修改弹窗显示方法，使其传参与ht_add_sp保持一致
    dialogShow(dataSourcesId, auditDialog = 0, parm = null, id = null, maker = null, makerTime = null){
        this.billId = dataSourcesId;
        this.dataId = id;
        
        // 保存传入的制单人和时间
        this.createdBy = maker;
        this.createdTime = makerTime;
        
        // 处理审批参数
        if(parm && parm.id){
          this.auditParm = parm;
          this.dialogInfoData.btList[0].show = true;
          this.showAuditForm = true;
          
          // 初始化审核表单数据
          this.$nextTick(() => {
            for (const key in this.formInfo2.data) {
              this.formInfo2.data[key] = '';
            }
            
            // 查找并设置流程名称
            const loadProcessEnum = () => {
              return new Promise((resolve) => {
                if (this.listTypeInfo.processId && this.listTypeInfo.processId.length > 0) {
                  resolve();
                } else {
                  this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {
                    if(res.code == 0) {
                      let list1 = res.data.list
                      for(let i in list1) {
                        this.listTypeInfo.processId.push({value: list1[i].processId, enumValue: list1[i].processCode, label: list1[i].name})
                      }
                      resolve();
                    } else {
                      this.$message({ message: '加载流程枚举失败: ' + res.msg, type: 'error' })
                      resolve();
                    }
                  }).catch(() => {
                    resolve();
                  });
                }
              });
            };
            
            // 加载流程枚举后再设置流程名称
            loadProcessEnum().then(() => {
              let processFound = false;
              for (let inde of this.listTypeInfo.processId) {
                if (parm.processId == inde.enumValue) {
                  this.formInfo2.data.processId = inde.value;
                  processFound = true;
                  break;
                }
              }
              
              // 如果没找到匹配的流程，记录日志并设置一个默认值
              if (!processFound) {
                console.warn('未找到匹配的流程ID:', parm.processId, '可用的流程枚举:', this.listTypeInfo.processId);
                // 直接使用processId作为备选
                this.formInfo2.data.processId = parm.processId;
              }
              
              this.formInfo2.data.status = 1;
            });
          });
        }else{
          this.dialogInfoData.btList[0].show = false;
          this.showAuditForm = false;
        }
        
        // 获取数据
        this.getInfo(dataSourcesId);
    },
    formatAmount(cellValue) {
      if (typeof cellValue == 'number') {
        cellValue = Number(cellValue.toFixed(2))
        return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }else{
          return cellValue
      }
    },
    // 获取装柜审批信息
    getInfo (dataSourcesId) {
      // 获取装柜数据
this.$api.OrderPurchase.getPurOrderContainerPage1({id: dataSourcesId, pageNum:1, pageSize:999}).then(res => {
  if (res.code == 0) {
    console.log('API返回数据:', res.data); // 添加这行来调试
    
    if (res.data && res.data.list) {
      // 情况1：如果返回的是列表数据
      this.tableData = res.data.list;
    } else if (res.data) {
      // 情况2：如果返回的是单个对象（根据你的描述可能是这种情况）
      this.tableData = [res.data];
    } else {
      this.$message({ message: '对应装柜数据为空', type: 'warning' });
      this.tableData = [];
    }
    
    // 填充表单数据
    if (res.data) {
      const dataToUse = res.data.list ? res.data.list[0] : res.data;
      for (let key in dataToUse) {
        if (key in this.formInfo.data) {
          this.formInfo.data[key] = dataToUse[key];
        }
      }
      this.detailDate = dataToUse;
    }
    
    this.dialogInfoData.visible = true;
  } else {
    this.$message({ message: res.msg, type: "error" });
    this.tableData = [];
  }
}).catch(err => {
  console.log('API调用错误:', err);
  this.$message({ message: '获取装柜数据失败', type: "error" });
  this.tableData = [];
});},
    dialogEventData(event){
    const dialogInfoData = this.dialogInfoData;
    switch (event) {
        case 'save':
          this.formInfo2.ref.validate(valid => {
            if (valid) {
              let parma = {
                id: this.auditParm.id,
                processId: this.formInfo2.data.processId,
                status: this.formInfo2.data.status,
                remark: this.formInfo2.data.remark
              };
              dialogInfoData.btList[0].loading = true;
              
              // 修改这里：使用正确的API方法名
              this.$api.system.approval(parma).then(res => {
                dialogInfoData.btList[0].loading = false;
                if (res.code === 0) {
                  this.$message({ message: res.msg, type: 'success' });
                  dialogInfoData.visible = false;
                  this.showAuditForm = false; // 修改这里：使用正确的变量名
                  this.$emit('approvalInfo');
                } else {
                  this.$message({ message: res.msg, type: 'error' });
                }
              }).catch(() => {
                dialogInfoData.btList[0].loading = false;
              });
            }
          });
          break;
        case 'close':
            dialogInfoData.visible = false;
            this.showAuditForm = false; // 修改这里：使用正确的变量名
            break;
        case 'opened':
            // 弹窗打开时的处理
            break;
    }
},
    handlePictureCardPreview(url) {
      if(url){
        window.open(this.pingImgUrl + url);
      }
    },
    viewFile(fileUrl) {
        if (fileUrl) {
            // 如果已经是完整URL，直接打开
            if (fileUrl.startsWith('http')) {
                window.open(fileUrl);
            } else {
                // 否则拼接基础URL
                window.open(this.pingImgUrl + fileUrl);
            }
        }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = this.formatAmount(sums[index]);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    insertQuickPhrase(phrase) {
        // 获取当前备注值
        const currentRemark = this.formInfo2.data.remark || '';
        
        // 插入短语到备注中
        if (currentRemark) {
            this.formInfo2.data.remark = currentRemark + ' ' + phrase;
        } else {
            this.formInfo2.data.remark = phrase;
        }
    },
    addNewPhrase() {
        if (this.newPhrase.trim()) {
            this.quickPhrases.push(this.newPhrase.trim());
            this.newPhrase = '';
        }
    },
    removePhrase(index) {
        this.quickPhrases.splice(index, 1);
    },
  }
}
</script>

<style lang="stylus" scoped>
.custom-steps-vertical
  .el-step__description
    padding-left 10px

.quick-phrase-area {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
}

.quick-phrase-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #606266;
}

.quick-phrase-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.phrase-btn {
  margin: 0;
  white-space: nowrap;
}

.phrase-manager-btn {
  margin: 0;
}

.phrase-manager {
  max-height: 400px;
  overflow-y: auto;
}

.phrase-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.phrase-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-delete-btn {
  flex-shrink: 0;
}

.phrase-add {
  display: flex;
  margin-top: 15px;
}

.phrase-add-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-add-btn {
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Custom/LoadingVerificationDialog.vue